import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// StripePayment archetype — collects a payment method via Stripe Elements
// and stores the resulting payment_method id in draft.payload.billing.stripePmId.
//
// This is a control archetype (isFormArchetype: false) — it owns its own
// advance() call once the SetupIntent succeeds, rather than participating
// in the per-stage form aggregator.
//
// The Stripe Elements UI is host-provided via `adapters.renderStripePaymentForm`
// to keep @stripe/* out of the wizard-blocks package bundle. The portal's
// CompoundStep wires the real implementation; in tests a stub can be
// passed instead.
//
// Flow:
//   1. Render — calls `adapters.renderStripePaymentForm({ onSuccess, onError })`
//      which the host uses to mount a Stripe Elements form inside this slot.
//   2. onSuccess(pmId) — host calls back with the confirmed payment method id.
//   3. Component advances with `{ billing: { stripePmId: pmId } }`.
import { useState } from 'react';
export function StripePaymentComponent(props) {
    const { adapters, advance, back, isAdvancing } = props;
    const [error, setError] = useState(null);
    const [saving, setSaving] = useState(false);
    async function onSuccess(pmId) {
        setSaving(true);
        setError(null);
        try {
            await advance({ billing: { stripePmId: pmId } });
        }
        catch (e) {
            setError(e instanceof Error ? e.message : 'Could not save the payment method. Please try again.');
            setSaving(false);
        }
    }
    function onError(msg) {
        setError(msg);
    }
    const formNode = adapters.renderStripePaymentForm
        ? adapters.renderStripePaymentForm({ onSuccess, onError })
        : null;
    return (_jsxs("div", { className: "flex flex-col gap-4", children: [!adapters.renderStripePaymentForm && (_jsx("div", { className: "rounded-md border border-[var(--bcbb-border)] bg-[var(--bcbb-surface-2)] px-3 py-4 text-sm text-[var(--bcbb-text-muted)]", children: "Payment form is not available in this environment." })), formNode, error && (_jsx("div", { className: "rounded-md bg-[var(--bcbb-danger-bg,#fde0df)] px-3 py-2 text-sm text-[var(--bcbb-danger)]", children: error })), (saving || isAdvancing) && (_jsx("div", { className: "text-sm text-[var(--bcbb-text-muted)]", children: "Saving payment method\u2026" })), _jsx("div", { className: "mt-2 flex items-center justify-between gap-3", children: _jsx("button", { type: "button", onClick: back, disabled: saving || isAdvancing, className: "rounded-md border bg-white px-4 py-2 text-sm font-medium", style: { borderColor: 'var(--bcbb-border)' }, children: "Back" }) })] }));
}
export const StripePaymentArchetype = {
    name: 'StripePayment',
    label: 'Payment (Stripe)',
    description: 'Collects a payment method via Stripe Elements and stores the payment method id in the draft payload.',
    component: StripePaymentComponent,
    isFormArchetype: false,
    fields: {},
    defaultConfig: {},
};
